import React, { createContext, useContext, useState, useCallback } from 'react';

const ConversationRefreshContext = createContext({});

export const useConversationRefresh = () => useContext(ConversationRefreshContext);

export const ConversationRefreshProvider = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshConversations = useCallback(() => {
    console.log('Refreshing conversations...');
    setRefreshKey(prev => prev + 1);
  }, []);

  const value = {
    refreshKey,
    refreshConversations
  };

  return (
    <ConversationRefreshContext.Provider value={value}>
      {children}
    </ConversationRefreshContext.Provider>
  );
};
